import { useQuery } from '@tanstack/react-query';
import {
  GetEntitySuggestionResponseSchema,
  type GetEntitySuggestionResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { entitySuggestionKeys } from '../query-keys';

export function useEntitySuggestion(id: string | undefined) {
  return useQuery({
    queryKey: entitySuggestionKeys.detail(id),
    enabled: !!id,
    queryFn: async () => {
      const { data } = await apiClient.get<GetEntitySuggestionResponse>(
        `/api/v2/entity-suggestion/${id}`
      );
      return GetEntitySuggestionResponseSchema.parse(data).data;
    }
  });
}
